import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFichaEspectaculoById } from 'services/servicioGet';
import { IFichaEspectaculo } from 'utils/models/types';

interface EspectaculoPorIdState {
  fichaEspectaculo: IFichaEspectaculo;
  loadingFichaEspectaculo: boolean;
  errorFichaEspectaculo: string | null;
}

// Estado inicial
const initialStateEspectaculo = {
  Id: 0,
  VisibleEnGrilla: true,
  Nombre: '',
  Descripcion: '',
  AficheUrl: '',
  Fotos: [],
  SalaId: 1,
  AforoDisponible: 0,
  Autor: '',
  Elenco: '',
  Director: '',
  GeneroId: 1,
  Precio: 0,
  Banner: '',
  AsistenteDireccion: '',
  Vestuarista: '',
  Iluminador: '',
  Sonidista: '',
  Musica: '',
  DisenoGrafico: '',
  Fotografia: '',
  Escenografia: '',
  Traduccion: '',
  PorcentajeAgadu: 0,
  PorcentajeCofonte: 0,
  TipoElencoId: 1,
  Funciones: [],
};

// Estado inicial del slice
const initialState: EspectaculoPorIdState = {
  fichaEspectaculo: initialStateEspectaculo,
  loadingFichaEspectaculo: false,
  errorFichaEspectaculo: null,
};

// Thunk para obtener la ficha de espectáculo
export const fetchFichaEspectaculoPorId = createAsyncThunk<
  IFichaEspectaculo,
  number, // Id del espectáculo
  { rejectValue: string }
>('espectaculos/fetchFichaEspectaculoPorId', async (id, thunkAPI) => {
  try {
    const response = await getFichaEspectaculoById(id.toString());
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue('Error al cargar el espectáculo');
  }
});

// Slice de espectaculo por id
const espectaculoFichaSlice = createSlice({
  name: 'fichaEspectaculo',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFichaEspectaculoPorId.pending, state => {
        state.loadingFichaEspectaculo = true;
        state.errorFichaEspectaculo = null;
      })
      .addCase(fetchFichaEspectaculoPorId.fulfilled, (state, action) => {
        state.fichaEspectaculo = action.payload;
        state.loadingFichaEspectaculo = false;
      })
      .addCase(fetchFichaEspectaculoPorId.rejected, (state, action) => {
        state.loadingFichaEspectaculo = false;
        state.errorFichaEspectaculo = action.payload as string;
      });
  },
});

export default espectaculoFichaSlice.reducer;
